import type { ApiAccessKey } from '../@types/ApiAccessKey';
import type { Actions } from '../actions';
import {
  RCV_ADD_ACCESS_KEY,
  RCV_CREATE_API_CONSUMER,
  RCV_FETCH_API_CONSUMER,
  RCV_REMOVE_ACCESS_KEY,
  RCV_REMOVE_API_CONSUMER,
  RCV_UPDATE_API_CONSUMER,
  REQ_ADD_ACCESS_KEY,
  REQ_CREATE_API_CONSUMER,
  REQ_FETCH_API_CONSUMER,
  REQ_REMOVE_ACCESS_KEY,
  REQ_REMOVE_API_CONSUMER,
  REQ_UPDATE_API_CONSUMER,
  REQUEST_FAILED,
} from '../actions/api-access-key';
import { requestStatus, responseStatus } from '../shared/statuses';

// Verify model...
const initialApiConsumer = { keys: [] } as unknown as ApiAccessKey;
const getInitialApiConsumer = () => ({ ...initialApiConsumer });

interface ApiAccessKeysState {
  requestStatus: number;
  responseStatus: number;
  current: ApiAccessKey;
}

const _initialState: ApiAccessKeysState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  current: getInitialApiConsumer(),
};

const apiAccessKeysReducer = (
  state: ApiAccessKeysState = _initialState,
  action: Actions,
): ApiAccessKeysState => {
  let current = null;
  let keys = null;
  let index = -1;

  switch (action.type) {
    case REQ_FETCH_API_CONSUMER:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_FETCH_API_CONSUMER:
      return {
        ...state,
        current: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_CREATE_API_CONSUMER:
      return {
        ...state,
        requestStatus: requestStatus.CREATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_CREATE_API_CONSUMER:
      return {
        ...state,
        current: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_UPDATE_API_CONSUMER:
      return {
        ...state,
        requestStatus: requestStatus.UPDATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_UPDATE_API_CONSUMER:
      return {
        ...state,
        current: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_REMOVE_API_CONSUMER:
      return {
        ...state,
        requestStatus: requestStatus.REMOVING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_REMOVE_API_CONSUMER:
      return {
        ...state,
        current: getInitialApiConsumer(),
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };

    case REQ_ADD_ACCESS_KEY:
      return {
        ...state,
        requestStatus: requestStatus.UPDATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_ADD_ACCESS_KEY:
      current = { ...state.current };
      keys = state.current.keys.slice();
      keys.push(action.response);
      current.keys = keys;
      return {
        ...state,
        current,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_REMOVE_ACCESS_KEY:
      return {
        ...state,
        requestStatus: requestStatus.UPDATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_REMOVE_ACCESS_KEY:
      current = { ...state.current };
      keys = state.current.keys.slice();
      index = keys.findIndex((is) => is.id === action.response.id);

      if (index >= 0) {
        keys.splice(index, 1);
      }
      current.keys = keys;
      return {
        ...state,
        current,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };

    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default apiAccessKeysReducer;
